"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _slice = require("./quote/slice");
var _slice2 = require("./form/slice");
var _slice3 = require("./app/slice");
var _slice4 = require("./partner/slice");
var rootReducer = (0, _toolkit.combineReducers)({
  quote: _slice.quoteSlice.reducer,
  form: _slice2.formSlice.reducer,
  app: _slice3.appSlice.reducer,
  partner: _slice4.partnerSlice.reducer
});
var _default = exports["default"] = rootReducer;